<nh-form [formGroup]="getForm()" (validate)="validate($event)">
  @if (modules && form) {
  <section>
    <div class="row py-3">
      <div class="col-12">
        @if (showKtMsg) {
        <p>
          {{ "RMC_STATIC_TEXT01" | globalTranslate }}
          <a tabindex="0" (click)="toTenncare()" class="add-primary-color"
            [attr.aria-label]="'CLICK_HERE_DASHBOARD' | globalTranslate">{{ "RMC_STATIC_TEXT02" | globalTranslate }}</a>
        </p>
        }
        <p class="static-text" [innerHTML]="'REPORT_CHANGES__START_STATIC_TEXT1' | globalTranslate"></p>
        <h1 class="section-header">
          <strong>{{ "REPORT_MY_CHANGES" | globalTranslate }}</strong>
        </h1>
        <hr />
        <p class="static-text" [innerHTML]="'REPORT_CHANGES__START_STATIC_TEXT2' | globalTranslate"></p>
      </div>
    </div>
    <div class="row report-grid">
      @if(rmcVolTermChangeSwitch){
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT30' | globalTranslate
          " [ngClass]="{
            selected: endCoverage,
            disabled: disable('endCoverage')
          }" (click)="toggleValue('endCoverage')" (keydown.enter)="toggleValue('endCoverage')"
          (keydown.space)="$event.preventDefault(); toggleValue('endCoverage')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/End Coverage.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT30" | globalTranslate
                }}</strong>
            </div>
            <ul>
              <li class="description">
                {{ "RMC_ENDCOVERAGE_DESCRIPTION" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      }
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT3' | globalTranslate
          " [ngClass]="{
            selected: contactInfo,
            disabled: disable('contactInfo')
          }" (click)="toggleValue('contactInfo')" (keydown.enter)="toggleValue('contactInfo')"
          (keydown.space)="$event.preventDefault(); toggleValue('contactInfo')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Contact Info.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT3" | globalTranslate
                }}</strong>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT4" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT5" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT6' | globalTranslate
          " [ngClass]="{
            selected: houseHoldMembers,
            disabled: disable('houseHoldMembers')
          }" (click)="toggleValue('houseHoldMembers')" (keydown.enter)="toggleValue('houseHoldMembers')"
          (keydown.space)="
            $event.preventDefault(); toggleValue('houseHoldMembers')
          ">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Household Members.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT6" | globalTranslate
                }}</strong>
            </div>
            <ul>
              <li class="description" [innerHTML]="
                  'REPORT_CHANGES__START_STATIC_TEXT35' | globalTranslate
                "></li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT8" | globalTranslate }}
              </li>
              <li class="description">
                {{ (updateToNonQualifiedCitizenshipSwitch ? "REPORT_CHANGES__START_STATIC_TEXT36" :
                "REPORT_CHANGES__START_STATIC_TEXT7") | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT9" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT10" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT11' | globalTranslate
          " [ngClass]="{
            selected: houseHoldInfo,
            disabled: disable('houseHoldInfo')
          }" (click)="toggleValue('houseHoldInfo')" (keydown.enter)="toggleValue('houseHoldInfo')" (keydown.space)="
            $event.preventDefault(); toggleValue('houseHoldInfo')
          ">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Household Info.png" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT11" | globalTranslate
                }}</strong>
              <nh-popover class="ps-1 householdTooltip" content="{{
                  'REPORT_CHANGES__START_STATIC_TEXT33' | globalTranslate
                }}"></nh-popover>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT12" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT13" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT9' | globalTranslate
          " [ngClass]="{ selected: tax, disabled: disable('tax') }" (click)="toggleValue('tax')"
          (keydown.enter)="toggleValue('tax')" (keydown.space)="$event.preventDefault(); toggleValue('tax')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/TaxInformation.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT9" | globalTranslate
                }}:</strong>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT14" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT15' | globalTranslate
          " [ngClass]="{ selected: income, disabled: disable('income') }" (click)="toggleValue('income')"
          (keydown.enter)="toggleValue('income')" (keydown.space)="$event.preventDefault(); toggleValue('income')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Income&Employment.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT15" | globalTranslate
                }}</strong>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT16" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT17" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT18" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT19' | globalTranslate
          " [ngClass]="{ selected: other, disabled: disable('other') }" (click)="toggleValue('other')"
          (keydown.enter)="toggleValue('other')" (keydown.space)="$event.preventDefault(); toggleValue('other')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/OtherBenefits.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT19" | globalTranslate
                }}</strong>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT20" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT21" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT22" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT23" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0"
          [attr.aria-label]="'OTHER_HEALTHCARE_STATIC_TEXT44' | globalTranslate"
          [ngClass]="{ selected: transfer, disabled: disable('transfer') }" (click)="toggleValue('transfer')"
          (keydown.enter)="toggleValue('transfer')" (keydown.space)="$event.preventDefault(); toggleValue('transfer')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Resources.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "OTHER_HEALTHCARE_STATIC_TEXT44" | globalTranslate
                }}</strong>
            </div>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="'EXPENSES' | globalTranslate"
          [ngClass]="{ selected: expenses, disabled: disable('expenses') }" (click)="toggleValue('expenses')"
          (keydown.enter)="toggleValue('expenses')" (keydown.space)="$event.preventDefault(); toggleValue('expenses')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Expenses.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{ "EXPENSES" | globalTranslate }}</strong>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT24" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT25" | globalTranslate }}
              </li>
              <li class="description">
                {{ "Mandatory Payments" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT26" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT34" | globalTranslate }}
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="'RESOUCES' | globalTranslate"
          [ngClass]="{ selected: assets, disabled: disable('assets') }" (click)="toggleValue('assets')"
          (keydown.enter)="toggleValue('assets')" (keydown.space)="$event.preventDefault(); toggleValue('assets')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/Resources.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{ "RESOUCES" | globalTranslate }}</strong>
            </div>
            <ul>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT27" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT28" | globalTranslate }}
              </li>
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT29" | globalTranslate }}
              </li>
              <li class="description">{{ "Vehicles" | globalTranslate }}</li>
            </ul>
          </span>
        </div>
      </div>
      @if(!rmcVolTermChangeSwitch){
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" [attr.aria-label]="
            'REPORT_CHANGES__START_STATIC_TEXT30' | globalTranslate
          " [ngClass]="{
            selected: endCoverage,
            disabled: disable('endCoverage')
          }" (click)="toggleValue('endCoverage')" (keydown.enter)="toggleValue('endCoverage')"
          (keydown.space)="$event.preventDefault(); toggleValue('endCoverage')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/End Coverage.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header">
              <strong>{{
                "REPORT_CHANGES__START_STATIC_TEXT30" | globalTranslate
                }}</strong>
            </div>
            @if (rmcVolTermChangeSwitch) {
            <ul>
              <li class="description">
                {{ "RMC_ENDCOVERAGE_DESCRIPTION" | globalTranslate }}
              </li>
            </ul>
            }
          </span>
        </div>
      </div>
      }
      @if (showKtTile) {
      <div class="col-md-12 report-section">
        <div class="sections border p-4 m-3" tabindex="0" aria-label="Katie Beckett"
          [ngClass]="{ selected: kb, disabled: disable('kb') }" (click)="toggleValue('kb')"
          (keydown.enter)="toggleValue('kb')" (keydown.space)="$event.preventDefault(); toggleValue('kb')">
          <span class="section-column">
            <img class="col dot" aria-hidden="true" alt="" src="assets/images/Report changes/KatieBeckett.svg" />
          </span>
          <span class="section-column">
            <div class="tile_header"><strong>Katie Beckett:</strong></div>
            <ul>
              @if (changeKt) {
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT31" | globalTranslate }}
              </li>
              } @if (referralKt) {
              <li class="description">
                {{ "REPORT_CHANGES__START_STATIC_TEXT32" | globalTranslate }}
              </li>
              }
            </ul>
          </span>
        </div>
      </div>
      }
    </div>
    @if (!closePregDueDateNudge) {
    <div>
      @if (showPregDueDateNudge === 'Y') {
      <nh-nudge [message]="'NUDGETEXT_03' | globalTranslate"></nh-nudge>
      }
    </div>
    }
  </section>
  }
</nh-form>